import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const NumberRow = styled(FlexRow)<{ bold?: boolean; highlighted?: boolean }>`
    align-items: center;
    flex-direction: row-reverse;
    font-size: 14px;
    font-weight: ${({ bold }) => (bold ? 500 : 400)};
    line-height: 16px;
    color: ${({ highlighted }) => (highlighted ? "rgba(42,61,83,0.8)" : "#2A3D53")};
    font-family: Roboto;
`;
NumberRow.displayName = "NumberRow";
